export enum UnavailabilityType {
    CRM = "CRM",
    SENV = "SENV"
}
